import React, { useState, useEffect, useRef } from 'react';
import styles from './styles.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';

const SearchContainer = ({
  setContainerName,
  setPage,
  width,
  placeholder,
  className,
  autoFocus = false,
  initialQuery = '',
}) => {
  const [query, setQuery] = useState(initialQuery);
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const inputRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    setQuery(initialQuery || '');
  }, [initialQuery]);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [autoFocus]);

  // Debounce logic
  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      setDebouncedQuery(query);
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [query]);

  // API call when debounced query changes
  useEffect(() => {
    setContainerName(debouncedQuery);
    setPage && setPage(1);
  }, [debouncedQuery]);

  const clearSearch = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
    }
    setQuery('');
    setDebouncedQuery('');
    setContainerName('');
    if (setPage) setPage(1);
    if (inputRef.current) inputRef.current.focus();
  };

  const showClear = String(query).trim() !== '';

  return (
    <div
      className={`${styles.searchContainer} ${className}`}
      style={{ width: width }}>
      <ReactSVG
        src={Icons.searchIcon}
        className={styles.search}
        beforeInjection={(svg) => {
          svg.querySelectorAll('path').forEach((path) => {
            path.setAttribute('stroke', '#99A0AE');
          });
        }}
      />
      <div className={styles.searchInputWrap}>
        <input
          ref={inputRef}
          type="text"
          className={styles.inputsearch}
          placeholder={placeholder || 'Search Container Number...'}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoComplete="off"
          data-form-type="search"
          name="search-container-input"
          id="search-container-input"
        />
      </div>
      {showClear ? (
        <button
          type="button"
          className={styles.searchClearBtn}
          onMouseDown={clearSearch}
          onClick={(e) => {
            if (e.detail === 0) clearSearch(e);
          }}
          aria-label="Clear search">
          <ReactSVG
            src={Icons.close}
            className={styles.searchClearIcon}
            beforeInjection={(svg) => {
              svg.setAttribute('width', '14');
              svg.setAttribute('height', '14');
              svg.querySelectorAll('path').forEach((path) => {
                path.setAttribute('stroke', '#99A0AE');
              });
            }}
          />
        </button>
      ) : null}
    </div>
  );
};

export default SearchContainer;
